"use client";
import { ICON_COLORS as o } from "../../tokens/icon-colors/IconColors.js";
import { ICONS as r } from "../../tokens/icons/Icons.js";
const e = Object.freeze({
  error: {
    color: o.red,
    colorAlias: "red",
    icon: r.danger,
    iconAlias: "danger"
  },
  info: {
    color: o.brand,
    colorAlias: "brand",
    icon: r.infoCircleFilled,
    iconAlias: "infoCircleFilled"
  },
  success: {
    color: o.green,
    colorAlias: "green",
    icon: r.checkCircle,
    iconAlias: "checkCircle"
  },
  warning: {
    color: o.orange,
    colorAlias: "orange",
    icon: r.warning,
    iconAlias: "warning"
  }
});
export {
  e as ICON_SEVERITY
};
